// src/services/api/index.ts - Базовый API клиент (ОБНОВЛЕННАЯ ВЕРСИЯ)
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptors для обработки токенов и ошибок
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Token ${token}`;  // Django использует Token, не Bearer
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      window.location.href = '/auth/login';
    }
    return Promise.reject(error);
  }
);

// Общие типы для API ответов
export interface ApiResponse<T = any> {
  success: boolean;
  data: T;
  message?: string;
}

export interface ApiError {
  success: false;
  message: string;
  errors?: Record<string, string[]>;
}

export interface PaginatedResponse<T> {
  items: T[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
    has_next: boolean;
    has_prev: boolean;
  };
}

// Базовые типы пользователя и ролей
export interface AdminUser {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  is_superuser: boolean;
  last_login: string | null;
  date_joined: string;
}

export interface AdminRole {
  role: 'admin' | 'manager' | 'kitchen' | 'operator';
  role_display: string;
  created_at: string;
  created_by?: string;
}

export interface AdminPermissions {
  can_manage_users: boolean;
  can_manage_catalog: boolean;
  can_manage_orders: boolean;
  can_manage_manufacturing: boolean;
  can_view_full_dashboard: boolean;
  can_view_orders_dashboard: boolean;
}

export interface LoginResponse {
  token: string;
  user: AdminUser;
  role: AdminRole | null;
  permissions: AdminPermissions;
}

// Экспорт API для отзывов
export * from './feedbacks';
export { feedbacksApi } from './feedbacks';

// Экспорт API для производства
export * from './manufacturing';
export { manufacturingApi } from './manufacturing';

// Экспорт API для чатов
export * from './chats';
export { chatsApi } from './chats';

// ✨ НОВОЕ: Экспорт API для амбассадоров
export * from './ambassadors';
export { ambassadorsApi } from './ambassadors';